import React from 'react'
import PropTypes from 'prop-types'
import Checkbox from '../../../checkbox/Checkbox'
import './LeftCheckboxWithLabel.scss'
import { TooltipProps } from '../../../tooltipManager/TooltipProps'
const rootClassName = 'component-table-left-checkbox-with-label'

export const LeftCheckboxWithLabel = (props) => {
  return (
    <div className={rootClassName}>
      <Checkbox {...props} />
      <span>{props.label}</span>
    </div>
  )
}

LeftCheckboxWithLabel.propTypes = {
  'tooltip-position': TooltipProps['tooltip-position'],
  'tooltip-text': TooltipProps['tooltip-text'],
  disabled: PropTypes.bool,
  value: PropTypes.bool,
  onChange: PropTypes.func,
  label: PropTypes.string
}
